import { useUserData } from '../flows/core/hooks/use-profile';

export const useIsHomeOwner = (): boolean | 'loading' => {
  const { user, loading } = useUserData();

  if (loading) return 'loading';

  return user?.currentMove?.toAddress?.ownership === 'OWN';
};
